<div class="d-flex">
  <div class="radio-buttons">
    <div *ngFor="let row of rows">
      <mat-radio-group (change)="setHeightAndWidth($event.value)">
        <mat-radio-button
          *ngFor="let entry of row; let first = first"
          [ngClass]="!first ? 'left-space' : ''"
          [checked]="
            heightAndWidthAware.height === entry.height &&
            heightAndWidthAware.width === entry.width
          "
          [value]="entry"
          >{{ entry.height + 'x' + entry.width }}</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
  <ng-container *ngIf="anyChosen">
    <div>
      <div
        *ngIf="heightAndWidthAware.height === heightAndWidthAware.width"
        class="spaced centered"
      >
        <div class="square subtitle-white">Vierkant</div>
      </div>

      <div
        *ngIf="heightAndWidthAware.height < heightAndWidthAware.width"
        class="spaced centered"
      >
        <div class="bordered">
          <div class="white-space"></div>
          <div class="rectangled-horizontal subtitle-white">Liggend</div>
        </div>
      </div>

      <div
        *ngIf="heightAndWidthAware.height > heightAndWidthAware.width"
        class="spaced centered"
      >
        <div class="bordered d-flex">
          <div class="rectangled-vertical subtitle-white">Staand</div>
          <div class="white-vertical"></div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
